import { format as dateFnsFormat, parse, isDate } from 'date-fns'

export function format (value, fmt) {
  if (value instanceof Date) {
    return dateFnsFormat(value, fmt || 'ddd, MMM Do, YYYY')
  }
  const date = parse(value)
  if (isDate(date)) {
    return dateFnsFormat(date, fmt || 'ddd, MMM Do, YYYY')
  }
  console.error('dateFilter只接受Date或可转为Date的参数')
  return ''
}

export default format
